import {
    ClipboardTaskListLtrRegular,
    DocumentBulletListRegular,
    HomeRegular,
    MoneyRegular,
    ShieldRegular,
} from '@fluentui/react-icons';

const iconMap: Record<string, React.ReactElement> = {
    Home: <HomeRegular />,
    Shield: <ShieldRegular />,
    ClipboardTaskListLtr: <ClipboardTaskListLtrRegular />,
    DocumentBulletList: <DocumentBulletListRegular />,
    Money: <MoneyRegular />,
};

export function getIconComponent(iconName: string): React.ReactElement {
    return iconMap[iconName] || <HomeRegular />;
}
